import bffAPI from 'services/api/bff';

export async function saveBillingAddress(retailerId, addressDetails) {
  return bffAPI.post(`/users/${retailerId}/address/billing`, addressDetails).then(({ data }) => data);
}
export async function saveShippingAddress(retailerId, addressDetails) {
  return bffAPI.post(`/users/${retailerId}/address/shipping`, addressDetails).then(({ data }) => data);
}
